module.exports = __webpack_public_path__ + "img/draw.a283ddc5.png";